import React,{useEffect,useState} from 'react';
import { gsap } from "gsap";
import Carousel from'./components/Carousel.jsx';
import axios from 'axios';
import Test from'./components/Test.jsx';
import Glide from '@glidejs/glide'

export default function App () {

  const [error, setError] = useState(null);
  const [isLoaded, setIsLoaded] = useState(false);
  const [tags, setTags] = useState([]);
  const [items, setItems] = useState([]);
  
  /*
  fetch("/wp-json/wp/v2/tags")
  .then(response => response.json())
  .then(data => {    
    setTags(data);
  })
  .catch(error => {
    console.log("E: "+error);
  })  


  let tagsToDisplay = [];
  tags.map((tag, index) => (
  tagsToDisplay[tag.id]=tag.name           

));

*/

  useEffect(() => {
    fetch("/wp-json/wp/v2/portfolio?per_page=8&_embed")
      .then(res => res.json())
      .then(
        (result) => {
          setIsLoaded(true);
          setItems(result);
        },
        // Note: it's important to handle errors here
        // instead of a catch() block so that we don't swallow
        // exceptions from actual bugs in components.
        (error) => {
          setIsLoaded(true);
          setError(error);
        }    


      )
  },
   [])

 
  if (error) {
    return <div>Error: {error.message}</div>;
  } else if (!isLoaded) {
    return <div class="center">Loading...</div>;
  } else {
    return (
      <div className="portfolioBlockData w-full px-8 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4">        
      {items.map((item, index) => ( 
                
        <div class="text-center aspect-video cursor-pointer" onClick={(e) => PortBoxAdd(index, e)}>
          
          <div class="min-h-fit py-[50%] w-full bg-cover bg-center borderedImg" style={{ backgroundImage: 'url('+item._embedded['wp:featuredmedia']['0'].media_details.sizes.medium_large.source_url+')' }}></div>
          <h3 class="pt-8 pb-4 font-bold uppercase">{item.title.rendered}</h3>
          
          
        </div>
      ))
       
      }
      
  
    </div>
    );
  }

  function PortBoxAdd(index, e) {
    if (document.getElementById("portfolioItem")){
    document.getElementById("portfolioItem").remove();
    }
    
    const width  = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    const height = window.innerHeight|| document.documentElement.clientHeight|| document.body.clientHeight;
      var mouseX = e.clientX;
      var mouseY = e.clientY;
    
    let divs = document.getElementsByClassName("portfolioBlockData")
    for (let i = 0; i < divs.length; i++) {
      const d = document.createElement("div")
      d.style.left = mouseX-(width/2) + "px";
      d.style.top = mouseY-(height/2) + "px";
      
      var el = document.createElement( 'html' );
      el.innerHTML = items[index].content.rendered;      

      /////// Paragrafy z postu portfolio
      var TextInside = el.getElementsByTagName('p');
      var TextInsideAll="";
      for (const element of TextInside) { 
        TextInsideAll+=element.outerHTML;
      }    
      /////// Obrazki z postu portfolio
      var ImgInside = el.getElementsByTagName('img');
      
      var ImgInsideAll=[];
      for (const element of ImgInside) { 
        const imgArray = element.attributes.srcset.value.split(",")
        const imgBgArray = imgArray[4].split(" ")
        ImgInsideAll.push(imgBgArray[1]);
      }

      gsap.fromTo(d, {scale: "0.2", opacity: 0.1}, {scale:1, opacity: 1, top: "50%", left: "50%", xPercent: -50, yPercent: -50, duration: 0.8, ease: "power2"});
      d.style.left = mouseX-(width/2) + "px";
      d.style.top = mouseY-(height/2) + "px";
      d.classList.add('w-screen', 'h-screen', 'bg-white', 'fixed')
      d.id = "portfolioItem"
      divs[i].appendChild(d)
      //ReactDOM.render(<SomeComponent/>, document.getElementById(id))
      document.getElementsByTagName('body')[0].style.overflow = 'hidden';
       

      
      ReactDOM.render(
        
        <>
        <Carousel options={items[index]} images = { ImgInsideAll } />
        <div class="absolute top-0 right-0 p-4 bg-gray-300 m-4 z-[140] cursor-pointer text-white " onClick={() => PortBoxRemove()}><ion-icon name="close-outline" class="w-6 h-6"></ion-icon></div>
               
            <div class="absolute bottom-[2%] xs:left-0 w-full sm:top-[15%] sm:top-[10%] xs:right-0 sm:left-[auto] sm:right-[10%] sm:w-[35%] infoBox z-[140]">
              <div class="p-8 bg-white border-2 border-primary m-8 h-auto inline-block align-middle">
                <h2 class="text-sm md:text-xl mt-0">{items[index].title.rendered}</h2>
                <p dangerouslySetInnerHTML={{__html: TextInsideAll}} class=" hidden sm:block xs:text-xs sm:text-sm lg:text-base"/>
              </div>
           
          
        </div> </>, document.getElementById("portfolioItem")        
      )
    }
    
  }

  function removeElement(element) {
    if (typeof(element) === "string") {
      element = document.querySelector(element);
    }
    return function() {
      element.parentNode.removeChild(element);
    };
  }

  function PortBoxRemove(){
    let portfolioItem = document.getElementById("portfolioItem");
    //portfolioItem.remove();
    let tl = gsap.timeline();
    tl.to(portfolioItem, {scale: "0.2", opacity: 0.0, duration: 0.2, ease: "power2"})
    .call(removeElement(portfolioItem));
    document.getElementsByTagName('body')[0].style.overflow = 'scroll';
  }


}
let renderF = () => {
  window.onload = function() {    
    const divsToUpdate = window.document.querySelectorAll('.portfolioBlock')
    console.log(divsToUpdate.length)
    divsToUpdate.forEach(function(div) {
        div.classList.remove(".portfolioBlock")
        ReactDOM.render(<App />, div)    
     })
    }; 
}
renderF();
/*
<div class="pb-4 mb-8">
          {item.tags.map((tag, index) => (            
              <span class="px-0.5 uppercase text-gray" key={index}>{tagsToDisplay[tag]} </span>
            ))}
            </div>
            */